import type { PublicPath } from "./LocaleLink";

export const headerLinks: { to: PublicPath; key: string }[] = [
  { to: "/", key: "home" },
  { to: "/nieuwbouw", key: "nieuwbouw" },
  { to: "/renovatie", key: "renovatie" },
  { to: "/technieken", key: "technieken" },
  { to: "/warmtepompen-afdekkingen", key: "warmtepompen" },
  { to: "/realisaties", key: "realisaties" },
  { to: "/opbouw-zwembad", key: "opbouw" },
  { to: "/blog", key: "blog" },
  { to: "/over-ons", key: "overOns" },
];